import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import SequentialEntrance from "vue-sequential-entrance";
import "vue-sequential-entrance/vue-sequential-entrance.css";
Vue.use(SequentialEntrance);

// Configuration VueAnalytics
import VueAnalytics from "vue-analytics";
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_ANALITYCS,
  router
});

import Echo from "laravel-echo";
window.Pusher = require("pusher-js");
window.Echo = new Echo({
  broadcaster: "pusher",
  key: "ef196e37f962c75a5de3",
  cluster: "us3"
  // forceTLS: true,
  // encrypted: true
});

import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

// import './assets/styles/index.css';
import "@/assets/styles/index.css";

import VueQuillEditor from "vue-quill-editor";

import "quill/dist/quill.core.css"; // import styles
import "quill/dist/quill.snow.css"; // for snow theme
import "quill/dist/quill.bubble.css"; // for bubble theme

Vue.use(VueQuillEditor /* { default global options } */);

Vue.use(require("vue-moment"));

import axios from "axios";
window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
window.axios.defaults.withCredentials = true;

Vue.config.productionTip = false;

// -------------------------------------------  public views -----------------------------------------------
Vue.component("menu-public", require("./components/MenuPublic.vue").default);
Vue.component("contact", require("./components/NewContact.vue").default);
Vue.component("events", require("./views/Events.vue").default);
Vue.component("pagination", require("laravel-vue-pagination"));
Vue.component("seller-register", require("./views/Register.vue").default);
Vue.component("new-form", require("./views/NewForm.vue").default);

Vue.component("idx", require("./views/GalleryIDX.vue").default);
Vue.component("scrolling", require("./views/ScrollingHouses.vue").default);
Vue.component("calendar", require("./views/Calendar.vue").default);
Vue.component("sales", require("./views/Reviews/Sales.vue").default);
Vue.component("management", require("./views/Reviews/Rentals.vue").default);
Vue.component("menu-buyer", require("./views/Clients/Menu.vue").default);
Vue.component(
  "client-reviews",
  require("./views/Reviews/ClientReviews.vue").default
);
Vue.component("review-form", require("./views/Reviews/Form.vue").default);
Vue.component(
  "buyer-profile",
  require("./views/Clients/ContentDisplays/Buyer-Client-Profile.vue").default
);
Vue.component(
  "edit-modal",
  require("./views/Clients/ContentDisplays/EditModal.vue").default
);
Vue.component(
  "buyer-docs",
  require("./views/Clients/ContentDisplays/Buyer-Docs-Index.vue").default
);
Vue.component(
  "buyer-search",
  require("./views/Clients/ContentDisplays/Home-Search-Index.vue").default
);
Vue.component("listings", require("./views/Listings.vue").default);
Vue.component(
  "footer-links",
  require("./views/Reviews/FooterLinks.vue").default
);
Vue.component("images", require("./views/Admin/360Images.vue").default);

Vue.component(
  "gallery-admin",
  require("./views/Admin/GalleryAdmin.vue").default
);

store.dispatch("getUser");
store.dispatch("getInventory");
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
